export default __webpack_public_path__ + "static/media/slider-3.08b2e13c.jpg";